import { SortDirection } from "@redotech/cockroachdb-codegen/congodb/sort-direction";
import { supportAnalyticsInputSchema } from "@redotech/redo-support-common/support/analytics/support-analytics-schemas";
import * as z from "zod";

const sortValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export const getAnalyticsDrilldown = {
  name: "getAnalyticsDrilldown" as const,
  input: z.object({
    // Validated against the drill-down registry server-side — the registry
    // (not this wire list) is the source of truth for which ids exist.
    analytic: z.string(),
    dateRange: z.object({ start: z.date(), end: z.date() }),
    objectType: z.enum(["conversation", "message"]),
    columns: z.array(z.string()).min(1),
    platforms: supportAnalyticsInputSchema.shape.platforms,
    bucketKey: z.string().optional(),
    // Narrows `dateRange` to one merchant-timezone calendar day/range.
    dayRange: z.object({ start: z.string(), end: z.string() }).optional(),
    dayInstant: z.date().optional(),
    sort: z
      .object({ field: z.string(), order: z.enum(SortDirection) })
      .optional(),
    cursor: z.array(sortValueSchema).optional(),
    limit: z.number().int().positive().max(200).optional(),
  }),
  output: z.object({
    items: z.array(z.record(z.string(), z.unknown())),
    nextCursor: z.array(sortValueSchema).nullable(),
  }),
};
